import { useRouteLoaderData } from '@remix-run/react'

import { type loader } from '#app/root'

export const useRootLoader = () => useRouteLoaderData<typeof loader>('root')!
